import { Center, Group, Paper, Title } from "@mantine/core";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { userTypes } from "../../AdminPages/Users/userTypes";
import { LoaderWrapper } from "../../components/LoaderWrapper";
import JobSeekersFollowingMe from "./JobSeekersFollowingMe";
import { loadJobSeekerFollowings } from "./loadData";

const JobSeekerFollowedBy = () => {
  const [followers, setFollowers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refresh, setRefresh] = useState(false);
  console.log(":", followers);
  useEffect(() => {
    loadJobSeekerFollowings(setLoading).then(setFollowers);
  }, [refresh]);
  return (
    <Paper bg={"transparent"}>
      <LoaderWrapper loading={loading}>
        {followers.filter((data) => {
          if (data.role === userTypes["Job Seekers"]) {
            return true;
          }
        }).length > 0 ? (
          <JobSeekersFollowingMe
            refresh={refresh}
            followers={followers}
            setLoading={setLoading}
            setRefresh={setRefresh}
          />
        ) : (
          <Center position="center">
            <Title order={1}>You currently do not have any followers</Title>
          </Center>
        )}
      </LoaderWrapper>
    </Paper>
  );
};

export default JobSeekerFollowedBy;
